import { apiService } from '../APIService';

export default {
  get(params) {
    return apiService.get('/admin-notifications', params);
  },
  create(params) {
    return apiService.post('/admin-notifications', params);
  },
  delete(id, params) {
    return apiService.delete(`/admin-notifications/${id}`, params);
  },
};
